import comp from "./Thumbnail";
export default comp;
